import { render, staticRenderFns } from "./ComingSoonModal.vue?vue&type=template&id=2b2af3b6&scoped=true&"
import script from "./ComingSoonModal.vue?vue&type=script&lang=ts&"
export * from "./ComingSoonModal.vue?vue&type=script&lang=ts&"
import style0 from "./ComingSoonModal.vue?vue&type=style&index=0&id=2b2af3b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2af3b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
